import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";

import api from "services/api";

import {
  BannerImage,
  LinkUltragazEnergia,
  ModalContainer,
  ModalHeader,
  ModalStyle,
} from "./styles";

const BannerEnergia = (): JSX.Element => {
  const [show, setShow] = useState(false);
  const [notificationId, setNotificationId] = useState("");

  useEffect(() => {
    (async () => {
      await loadApi();
    })();
  }, []);

  const loadApi = async (): Promise<void> => {
    try {
      const userId = localStorage.getItem("@UltragazEmpresarial:userId");
      const headers = {
        access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
      };
      const { data } = await api.get(
        `/industrial/customer/v1/users/notification?user-id=${userId}&type=MI`,
        {
          headers,
        }
      );

      const notificationData = data?.find((item) => {
        if (item.notification.description === "BANNER ENERGIA") {
          return item;
        }
        return false;
      });

      if (notificationData?.isShouldNotify) {
        setShow(true);
        setNotificationId(notificationData.notification.id);
      }
    } catch (err) {
      if (err) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  const saveApi = async (): Promise<void> => {
    try {
      if (notificationId) {
        const userId = localStorage.getItem("@UltragazEmpresarial:userId");
        const headers = {
          access_token: localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          ),
        };
        await api.put(
          `/industrial/customer/v1/users/notification`,
          {
            notificationId,
            userId,
          },
          {
            headers,
          }
        );
      }
    } catch (err) {
      if (err) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  const onHide = async (): Promise<void> => {
    setShow(false);
    await saveApi();
  };

  return (
    <ModalStyle
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalContainer>
        <ModalHeader>
          <MdClose size={24} onClick={onHide} />
        </ModalHeader>
        <LinkUltragazEnergia href="/ultragaz-energia" onClick={saveApi}>
          <BannerImage src="/static/banner-energia-2-acesso.png" />
        </LinkUltragazEnergia>
      </ModalContainer>
    </ModalStyle>
  );
};

export default BannerEnergia;
